export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    type: 'expand',
    width: 70,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: {
      content: 'expandContent',
    },
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 70,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'amzSkuNo',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('INDEX.form_label_amzSkuNo') || '产品sku编号',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'goodsName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    title: that.$l('INDEX.form_label_goodsName') || '产品名称',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'goodsName',
    },
  },
  {
    field: 'estmatRepQty',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    title: that.$l('form_label_estmatRepQty') || '需求数量',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'v_isFillMoq',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    title: that.$l('form_label_isFillMoq') || '是否达到moq要求',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'etaDate',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    title: that.$l('form_label_etaDate') || '预计FBA到货日期',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'orderDate',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    title: that.$l('form_label_orderDate') || '预计采购下单日期',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'last30DaysPerDay',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_last30DaysPerDay') || '过去30天日销售量',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'last14DaysPerDay',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_last14DaysPerDay') || '过去14天日销售量',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'last7DaysPerDay',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_last7DaysPerDay') || '过去7天日销售量',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'estimatePerDay',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_estimatePerDay') || '预估日销售量',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'fbaQty',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_fbaQty') || 'FBA库存',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'fbaDaysOfSupply',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_fbaDaysOfSupply') || 'FBA库存可售天数',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'productionLeadTime',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_productionLeadTime') || '成品生产周期天数',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'shipmentLeadTime',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_shipmentLeadTime') || '物流运输周期天数',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'ftyInvQty',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_ftyInvQty') || '国内库存数量',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'ftyDaysOfSupply',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_ftyDaysOfSupply') || '国内库存可售天数',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
